import './Stage.css'

const Stage = ({ h3, p, curve }) => {
  return (
    <div className='stage'>
      {curve && <img alt='' src={curve} />}
      <h3>{h3} этап</h3>
      <p>{p}</p>
    </div>
  )
}

export default Stage
